module.exports = __webpack_public_path__ + "static/media/icon_rules.f16a3f10.svg";